import store from '@/store';
import { api } from '@/utils/api';
import axios from '@axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchUOMs(ctx, queryParams) {
      console.log('=== UOMStoreModule fetchUOMs():', { queryParams });

      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;
        console.log('=== UOMStoreModule businessID', businessID);

        const params = {
          businessID,
          pageNumber: queryParams.page || 1,
          pageSize: queryParams.perPage || 10,
          searchTerm: queryParams.q || '',
        };

        // Only add isActive filter if it has a valid value (not null or undefined)
        if (queryParams.isActive !== null && queryParams.isActive !== undefined) {
          params.isActive = queryParams.isActive;
        }

        console.log('=== UOMStoreModule params', params);

        api
          .get(`/InventoryUnits/GetByPagination/${businessID}`, { params })
          .then((response) => {
            console.log('=== UOMStoreModule response', response.data);

            if ('status' in response.data && response.data.status === 'success') {
              // Check if the response has the expected structure
              const responseData = response.data.data;
              console.log('=== UOMStoreModule responseData structure:', responseData);
              
              // Handle different possible response structures
              let results = [];
              let pagination = { totalCount: 0 };
              
              if (Array.isArray(responseData)) {
                // If responseData is directly an array
                results = responseData;
                pagination = { totalCount: responseData.length };
              } else if (responseData && typeof responseData === 'object') {
                // If responseData is an object, look for units/results/items
                results = responseData.units || responseData.results || responseData.items || responseData.data || [];
                pagination = responseData.pagination || { totalCount: results.length };
              }
              
              console.log('=== UOMStoreModule processed results:', results);
              console.log('=== UOMStoreModule pagination:', pagination);
              
              // Add serial numbers to the data
              const units = Array.isArray(results) ? results.map((unit, index) => ({
                ...unit,
                serialNo: (queryParams.page - 1) * queryParams.perPage + index + 1
              })) : [];
              
              resolve({
                units,
                pagination
              });
            } else {
              reject('Error fetching Unit of Measures list');
            }
          })
          .catch((error) => reject(error));
      });
    },
    fetchUOM(ctx, { id }) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;

        api
          .get(`/InventoryUnits/LoadSelectedData/${id}/${businessID}`)
          .then((response) => {
            console.log('=== UOMStoreModule response', response.data);
            if ('status' in response.data && response.data.status === 'success') {
              resolve(response.data.data);
            } else {
              reject('Error fetching Unit of Measures list');
            }
          })
          .catch((error) => reject(error));
      });
    },
    addUOM(ctx, uomData) {
      uomData.businessID = store.state.user.businessID;

      return new Promise((resolve, reject) => {
        api
          .post(`/InventoryUnits/Save`, uomData)
          .then((response) => {
            console.log(response);
            resolve(response.data.data);
          })
          .catch((error) => reject(error));
      });
    },
    editUOM(ctx, uomData) {
      return new Promise((resolve, reject) => {
        api
          .post(`/InventoryUnits/Save`, uomData)
          .then((response) => {
            console.log(response);
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    deleteUOM(ctx, { id }) {
      return new Promise((resolve, reject) => {
        console.log('=== UOMStoreModule deleteUOM called with id:', id);

        api
          .delete(`/InventoryUnits/${id}`)
          .then((response) => {
            console.log('=== UOMStoreModule deleteUOM response:', response);
            resolve(response);
          })
          .catch((error) => {
            console.error('=== UOMStoreModule deleteUOM error:', error);
            reject(error);
          });
      });
    },
  },
};
